import script from "./BannerView.vue?vue&type=script&lang=ts&setup=true"
export * from "./BannerView.vue?vue&type=script&lang=ts&setup=true"

import "./BannerView.vue?vue&type=style&index=0&id=83dda65a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83dda65a"]])

export default __exports__